export enum DosageUnit {
    MICROGRAM = 'mcg',
    MILLIGRAM = 'mg',
    GRAM = 'g',
    KILOGRAM = 'Kg',
    MILLILITER = 'ml',
    LITER = 'L'
}
